module.exports = __webpack_public_path__ + "static/img/background5.e7d5940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background5.jpg
// module id = bc2K
// module chunks = 0